import { parseMaintenanceStatus, type IMaintenanceStatus } from '@featit/shared/maintenance';

interface HttpErrorLike {
  response?: {
    data?: unknown;
  };
}

export class MaintenanceInterruptionError extends Error {
  readonly maintenanceStatus: IMaintenanceStatus;
  readonly originalError: unknown;

  constructor(maintenanceStatus: IMaintenanceStatus, originalError: unknown) {
    // The global maintenance notice owns the user-facing message. Keeping this
    // empty also prevents legacy page-level Error.message renderers from
    // duplicating a transient deployment failure.
    super('');
    this.name = 'MaintenanceInterruptionError';
    this.maintenanceStatus = maintenanceStatus;
    this.originalError = originalError;
  }
}

export function maintenanceInterruptionFromHttpError(
  error: unknown,
): MaintenanceInterruptionError | null {
  if (isMaintenanceInterruptionError(error)) return error;
  const maintenanceStatus = parseMaintenanceStatus((error as HttpErrorLike)?.response?.data);
  return maintenanceStatus ? new MaintenanceInterruptionError(maintenanceStatus, error) : null;
}

export function isMaintenanceInterruptionError(
  error: unknown,
): error is MaintenanceInterruptionError {
  return error instanceof MaintenanceInterruptionError;
}
